import styled from "styled-components";

export const ProductsCounterWrapper = styled.div`
  width: 1260px;
  margin: 0 auto;
  margin-bottom: 20px;
`;

export const ProductsCounts = styled.span`
  color: #53a036;
`;
